module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?0c9f225e8f69c622f681cf1ed973cc3d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module id = tNtp
// module chunks = 42